import axiosClient from '../axiosClient';

export const getCategories = (params) =>
  axiosClient.get('/admin/categories', { params });

export const createCategory = (data) =>
  axiosClient.post('/admin/categories', data);

export const updateCategory = (id, data) =>
  axiosClient.put(`/admin/categories/${id}`, data);

export const deleteCategory = (id) =>
  axiosClient.delete(`/admin/categories/${id}`);
